import { Route } from "react-router";
import React from "react";
import { ProtectedRoute } from "./components";
import { UsersList, TenantList, PartnerSettings } from "@/pages";
import {
  permissionsUsersReadonly,
  permissionsTenantsReadonly,
  permissionsSettings,
} from "@/utils";
import { userRoutes } from "./userRoutes";
import { tenantRoutes } from "./tenantRoutes";

type argsType = {
  showLocations?: boolean;
  showAddLocation?: boolean;
  showEditLocation?: boolean;
  showDeleteLocation?: boolean;
};

export const partnerRoutes = (
  parentPath: string,
  args: argsType = {},
): React.ReactElement[] => [
  <Route
    key="partners-settings"
    path="settings"
    element={
      <ProtectedRoute
        element={<PartnerSettings />}
        codes={permissionsSettings}
        feature="common"
      />
    }
  />,
  <Route
    key="partners-users"
    path="users"
    element={
      <ProtectedRoute
        element={<UsersList userFilter="partner" parentPath={parentPath} />}
        codes={permissionsUsersReadonly}
      />
    }
  />,
  <Route
    key="partners-tenants"
    path="tenants"
    element={
      <ProtectedRoute
        element={<TenantList parentPath={parentPath} />}
        codes={permissionsTenantsReadonly}
      />
    }
  />,
  <Route path="users/:userId">{userRoutes(parentPath)}</Route>,
  <Route path="tenants/:tenantId">{tenantRoutes(parentPath, args)}</Route>,
];
